import React from "react";
import { currencyFormatter } from "../../../../../../_metronic/_helpers";
import { Card } from "react-bootstrap";
import VerifiedUserIcon from "@material-ui/icons/VerifiedUser";

export const TopUpInvoice = ({ topupPayment = {} }) => {
  // console.log(topupPayment);
  return (
    <>
      {topupPayment.status === "WAITING" && (
        <div className="row">
          <div className="col-lg-1"></div>
          <div className="col-lg-10">
            <div className="row">
              <div className="col">
                <h5>
                  {`${
                    topupPayment.payment_method_name
                  } ${topupPayment.payment_method_type &&
                    topupPayment.payment_method_type.replace(/_/g, " ")}`}
                </h5>
              </div>
            </div>
            <br />
            <div className="row">
              <div className="col">
                <Card>
                  <Card.Body
                    style={{
                      backgroundColor: "rgba(240, 240, 240, 0.7)",
                    }}
                  >
                    {topupPayment.payment_account_number_code && (
                      <>
                        <span>Biller Kode </span>
                        <Card.Text
                          as="h4"
                          className="mt-2 d-flex justify-content-between"
                        >
                          <b>{topupPayment.payment_account_number_code}</b>
                          <button
                            className="btn btn-outline-dark float-right"
                            onClick={() => {
                              navigator.clipboard.writeText(
                                topupPayment.payment_account_number_code
                              );
                            }}
                          >
                            Copy
                          </button>
                        </Card.Text>
                      </>
                    )}
                    <br />
                    <span>Nomor Virtual Account</span>
                    <Card.Text
                      as="h4"
                      className="mt-2 d-flex justify-content-between"
                    >
                      <b>{topupPayment.payment_account_number}</b>
                      <button
                        className="btn btn-outline-dark float-right"
                        onClick={() => {
                          navigator.clipboard.writeText(
                            topupPayment.payment_account_number
                          );
                        }}
                      >
                        Copy
                      </button>
                    </Card.Text>
                  </Card.Body>
                </Card>
              </div>
            </div>

            <div className="row">
              <div className="col">
                <Card style={{ border: "none" }}>
                  <Card.Body>
                    <span>Jumlah Tagihan</span>
                    <Card.Text as="h4" className="mt-2">
                      <b>{currencyFormatter(topupPayment.payment_amount)}</b>
                    </Card.Text>
                  </Card.Body>
                </Card>
              </div>
            </div>
          </div>
          <div className="col-lg-1"></div>
        </div>
      )}
      {topupPayment.status === "PAID" && (
        <div className="row">
          <div className="col-lg-1"></div>
          <div className="col-lg-10">
            <div className="row">
              <div className="col">
                <Card>
                  <Card.Body
                    style={{
                      backgroundColor: "rgba(240, 240, 240, 0.7)",
                      textAlign: "center",
                    }}
                  >
                    <p>Terimakasih Banyak</p>
                    <Card.Text as="h4" className="mt-2">
                      Pembayaran anda telah kami terima!
                    </Card.Text>
                    <VerifiedUserIcon
                      style={{ color: "#43DEA3", fontSize: "86px" }}
                    />
                  </Card.Body>
                </Card>
              </div>
            </div>
          </div>
          <div className="col-lg-1"></div>
        </div>
      )}
    </>
  );
};
